export default {
  addressTextTransform: Styles.textTransform.headlines,
  directionsLinkStyledColor: Styles.color.grey.one,
};
